






































































import { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';

import {
  IFormTemplate,
  FormTemplateStateEnum,
  FormTemplate,
  IFormTemplateStatus
} from '@/models';

import { colors, classToHex } from '@/utils/colorUtils';

import auth from '@/mixins/auth';

import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import ErrorAlert from '../common/ErrorAlert.vue';

import Proxyable from '@/mixins/proxyable';
import mixins from '@/utils/mixins';
import { ErrorManager } from '@/models/error';
import EmployeeFormSubmissionDialog from '../employee-form/EmployeeFormSubmissionDialog.vue';

const baseMixins = mixins(auth, Proxyable);

interface Options extends InstanceType<typeof baseMixins> {
  /* eslint-disable-next-line camelcase */
  $refs: {
    employeeFormSubmissionDialog: InstanceType<
      typeof EmployeeFormSubmissionDialog
    >;
  };
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    name: 'FormBuilderDetailStateCard',

    components: {
      ConfirmationDialog,
      ErrorAlert,
      EmployeeFormSubmissionDialog
    },

    props: {
      value: {
        type: Object as PropType<IFormTemplate>
      }
    },

    data: () => ({
      FormTemplateStateEnum,
      loading: false,

      errorMessage: '',
      errorMessageDetail: ''
    }),

    computed: {
      ...mapGetters({
        getFormTemplateById: 'formTemplate/getFormTemplateById'
      }),

      formTemplateId(): number {
        return Number(this.$route.params.id);
      },

      formTemplate(): IFormTemplate {
        return this.getFormTemplateById(this.formTemplateId);
      },

      getStatusIcon(): string {
        return (this.formTemplate
          .state as IFormTemplateStatus).getCurrentState().icon!;
      },

      getStatusMessage(): string {
        return (this.formTemplate
          .state as IFormTemplateStatus).getCurrentState().display_name!;
      },

      getStatusColor(): string {
        return (this.formTemplate
          .state as IFormTemplateStatus).getCurrentState().color!;
      },

      getStatusHexColor(): string {
        return classToHex(
          (this.formTemplate.state as IFormTemplateStatus).getCurrentState()
            .color!,
          colors,
          this.$vuetify.theme.currentTheme
        );
      }
    },

    methods: {
      ...mapActions({
        updateFormTemplateState: 'formTemplate/updateFormTemplateState'
      }),

      openPreviewForm() {
        this.$refs.employeeFormSubmissionDialog.open(
          this.formTemplate,
          undefined,
          true
        );
      },

      updateState(state: FormTemplateStateEnum) {
        this.loading = true;
        this.updateFormTemplateState({
          id: this.formTemplate.id,
          state: state
        })
          .catch(error => {
            if (error.response && error.response.data.detail) {
              this.errorMessageDetail = error.response.data.detail;
            }
            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  });
